import { OnInit, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from "../../login/services/auth.service";
import { DacConfig } from "../../shared/services/dac-config.service";
import { NavBarService } from 'app/theme/services/nav-bar.service';
import { SidenavComponent } from 'ng-mdb-pro/pro';
var SidebarComponent = /** @class */ (function () {
    function SidebarComponent(navBarService, authService, dacConfig, router) {
        this.navBarService = navBarService;
        this.authService = authService;
        this.dacConfig = dacConfig;
        this.router = router;
    }
    SidebarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.navBarService.displaySideBarEvent.subscribe(function () {
            _this.sideNav.show();
        });
    };
    SidebarComponent.prototype.ngAfterViewInit = function () {
    };
    SidebarComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    SidebarComponent.prototype.handleItemClick = function (navBarItem, event) {
        if (navBarItem.id === 'logout') {
            this.logout();
            return;
        }
        this.navBarService.handleMenuItemClick(navBarItem, event);
    };
    SidebarComponent.prototype.show = function () {
        this.sideNav.show();
    };
    SidebarComponent.prototype.handleNavItemClick = function (navItem) {
        if (navItem.id === 'logout') {
            this.logout();
        }
    };
    Object.defineProperty(SidebarComponent.prototype, "navItems", {
        get: function () {
            return this.navBarService.navItemsForDisplay;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarComponent.prototype, "showSidebar", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarComponent.prototype, "logoUrl", {
        get: function () {
            return this.dacConfig.applicationLogoUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarComponent.prototype, "logoTitle", {
        get: function () {
            return this.dacConfig.applicationLogoTitle;
        },
        enumerable: true,
        configurable: true
    });
    SidebarComponent.prototype.logout = function () {
        var _this = this;
        this.authService.logout().then(function (resp) {
            if (resp.redirectUrl) {
                window.location.href = resp.redirectUrl;
            }
            else {
                _this.router.navigate(['/home']);
            }
        })
            .catch(function (error) {
            console.error(error);
            _this.router.navigate(["/home"]);
        });
    };
    return SidebarComponent;
}());
export { SidebarComponent };



// WEBPACK FOOTER //
// ./src/app/theme/sidebar/sidebar.component.ts.pre-build-optimizer.js